import { defineRoute } from './defineRoute';
import {
  ListingSearchCityRouteParams,
  ListingSearchStreetRouteParams,
} from './types';

export * from './types';

export const ROUTES = Object.freeze({
  Home: defineRoute('/'),
  Signup: defineRoute('/signup'),
  SignupSignin: defineRoute('/signup-signin'),

  // Search routes
  Search: defineRoute('/for-sale/properties-india'),

  ListingSearchCity: defineRoute<ListingSearchCityRouteParams>(
    '/for-sale/[typeAndCity]',
  ),

  ListingSearchStreet: defineRoute<ListingSearchStreetRouteParams>(
    '/for-sale/[typeAndCity]/[street]',
  ),

  ListingDetail: defineRoute<ListingSearchStreetRouteParams>(
    '/for-sale/[typeAndCity]/[street]/[typeAndListingId]',
  ),

  // Payment routes
  BillingDetails: defineRoute<{
    returnUrl?: string;
    selectedProduct?: string;
    selectedProductRatePlan?: string;
    isAfterPay?: string;
  }>('/premium-account-payment/personaldetails'),

  PaymentMethod: defineRoute<{
    returnUrl?: string;
    selectedProduct?: string;
    selectedProductRatePlan?: string;
  }>('/premium-account-payment/paymentmethod'),

  Profile: defineRoute('/profile'),

  CreateProperty: defineRoute('/agents/create-property'),

  MyProperties: defineRoute('/my-properties'),

  EditProperty: defineRoute<{ id: string }>('/edit-property/[id]'),

  TermsAndConditions: defineRoute('/terms'),

  ManageListing: defineRoute('/agents/manage-listing'),

  PrivacyPolicy: defineRoute('/privacy'),

  AboutUs: defineRoute('/about'),

  ContactUs: defineRoute('/contact-us'),

  HelpCenter: defineRoute('/help'),

  Inbox: defineRoute('/inbox'),

  Syndication: defineRoute('/syndication'),

  AgentsKnowledgeHub: defineRoute('/agents/knowledge-hub'),

  RealEstateInsights: defineRoute('/real-estate-insights'),

  RealEstateInsightsArticle: defineRoute<{ slug: string }>(
    '/real-estate-insights/[slug]',
  ),
});

/** routes that are publicly accessible but changes visually when a user is authenticated */
export const PUBLIC_ROUTES = Object.freeze([
  ROUTES.Home.pathname,
  ROUTES.Signup.pathname,
  ROUTES.SignupSignin.pathname,
  ROUTES.Search.pathname,
  ROUTES.ListingSearchCity.pathname,
  ROUTES.ListingSearchStreet.pathname,
  ROUTES.ListingDetail.pathname,
  ROUTES.BillingDetails.pathname,
  ROUTES.TermsAndConditions.pathname,
  ROUTES.PrivacyPolicy.pathname,
  ROUTES.AboutUs.pathname,
  ROUTES.ContactUs.pathname,
  ROUTES.HelpCenter.pathname,
  ROUTES.AgentsKnowledgeHub.pathname,
  ROUTES.RealEstateInsights.pathname,
  ROUTES.RealEstateInsightsArticle.pathname,
] as const);
